function errorMessage (errorCode) {
  let errorTip = '未知错误'
  switch (errorCode) {
    case 1001:
      errorTip = '请选择角色'
      break
    case 1002:
      errorTip = '请选择用户'
      break
    case 1003:
      errorTip = '账户密码不匹配'
      break
    case 1004:
      errorTip = '未接收到验证码'
      break
    case 2001:
      errorTip = '请选择配置信息'
      break
    case 3001:
      errorTip = '请选择设备'
      break
    case 3002:
      errorTip = '设备编号已存在'
      break
    case 3003:
      errorTip = '请选择设备版本'
      break
    case 3004:
      errorTip = '设备不存在'
      break
    case 4001:
      errorTip = '请选择mac地址'
      break
    case 4002:
      errorTip = '请选择设备固件版本'
      break
    case 4003:
      errorTip = '备注不得超过32位'
      break
    case 4004:
      errorTip = '请选择设备批次'
      break
    case 4005:
      errorTip = '此版本号不存在'
      break
    case 4006:
      errorTip = '版本信息不存在'
      break
    case 4007:
      errorTip = '请输入正确的版本号'
      break
    case 4008:
      errorTip = '升级版本文件命名有误'
      break
    case 5001:
      errorTip = '设备已入库，请不要重复入库'
      break
    case 5002:
      errorTip = '设备已出库，请不要重复出库'
      break
    case 5003:
      errorTip = '设备未出库'
      break
    case 6001:
      errorTip = '账号不存在'
      break
    case 6002:
      errorTip = '验证码错误'
      break
    case 6003:
      errorTip = '验签失败'
      break
    case 7001:
      errorTip = '添加失败，请确认参数是否有误'
      break
    case 7002:
      errorTip = '商户名称已存在'
      break
    case 7003:
      errorTip = '合作伙伴已存在'
      break
    case 8001:
      errorTip = '请选择产品型号'
      break
    default:
      errorTip = '未知错误'
  }
  return errorTip
}
export { errorMessage }



// WEBPACK FOOTER //
// ./src/util/errorCode.js